<template>
    <div id="app">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show">
                    <v-toolbar dark color="blue">
                        <v-toolbar-title>Planilla de Necesidades de Capacitación</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <div>
                            <v-btn icon @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-toolbar>
                    <v-card-text color="blue lighten-5">
                        <v-row dense>
                            <v-col cols="6" sm="6" md="4">
                                <h6> Nombre: {{ legajo }} - {{ nombre }} </h6>
                            </v-col>
                            <v-col cols="6" sm="6" md="4">
                                <h6> Responsable: {{ resp }} </h6>
                            </v-col>
                            <v-col cols="6" sm="6" md="2">
                                <h6> Fecha: {{ fecha }} </h6>
                            </v-col>
                            <v-col cols="6" sm="6" md="2">
                                <h6> Año: {{ periodo }} </h6>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="6" sm="3" md="3">
                                <h6> Gerencia: {{ gerencia }} </h6>
                            </v-col>
                            <v-col cols="12" sm="4" md="4">
                                <h6> Sector: {{ sector }} </h6>
                            </v-col>
                            <v-col cols="12" sm="4" md="5">
                                <h6> Puesto: {{ puesto }} </h6>
                            </v-col>

                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="blue lighten-5">
                    <v-data-table :headers="headers" :items="polivalencias" locale="es-ar" class="elevation-1"
                        :items-per-page="100" hide-default-footer>
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Polivalencias</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.nivelocu="{ item }">
                            <v-chip v-if="item.nivelocu == 'PC'" color="white">
                                PUEDE CAPACITAR
                            </v-chip>
                            <v-chip v-if="item.nivelocu == 'DO'" color="white">
                                DOMINA
                            </v-chip>
                            <v-chip v-if="item.nivelocu == 'CS'" color="white">
                                CONOCE SUFICIENTE
                            </v-chip>
                            <v-chip v-if="item.nivelocu == 'CP'" color="white">
                                CONOCE PARCIAL
                            </v-chip>
                        </template>
                        <template v-slot:item.nivelreq="{ item }">
                            <v-chip v-if="item.nivelreq == 'PC'" color="white">
                                PUEDE CAPACITAR
                            </v-chip>
                            <v-chip v-if="item.nivelreq == 'DO'" color="white">
                                DOMINA
                            </v-chip>
                            <v-chip v-if="item.nivelreq == 'CS'" color="white">
                                CONOCE SUFICIENTE
                            </v-chip>
                            <v-chip v-if="item.nivelreq == 'CP'" color="white">
                                CONOCE PARCIAL
                            </v-chip>
                        </template>
                        <template v-slot:item.formacion="{ item }">
                            <v-chip v-if="item.formacion == 'AA'" color="white">
                                Autoaprendizaje
                            </v-chip>
                            <v-chip v-if="item.formacion == 'CI'" color="white">
                                Capacitación Interna
                            </v-chip>
                            <v-chip v-if="item.formacion == 'CE'" color="white">
                                Capacitación Externa
                            </v-chip>
                            <v-chip v-if="item.formacion == 'IE'" color="white">
                                Capac. Interna/Externa
                            </v-chip>
                            <v-chip v-if="item.formacion == 'AC'" color="white">
                                Autoapr/C.Interna/C.Externa
                            </v-chip>
                            <v-chip v-if="item.formacion == 'VF'" color="white">
                                Visita Ferias/Expo/Fábricas
                            </v-chip>
                            <v-chip v-if="item.formacion == 'LN'" color="white">
                                Lectura Normas
                            </v-chip>
                            <v-chip v-if="item.formacion == 'OT'" color="white">
                                Otras
                            </v-chip>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card>
                    <v-data-table :headers="headersPC" :items="policompetencias" locale="es-ar" class="elevation-1"
                        :items-per-page="100" hide-default-footer>
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Policompetencias</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.nivelocu="{ item }">
                            <v-chip v-if="item.nivelocu == 'PC'" color="white">
                                PUEDE CAPACITAR
                            </v-chip>
                            <v-chip v-if="item.nivelocu == 'DO'" color="white">
                                DOMINA
                            </v-chip>
                            <v-chip v-if="item.nivelocu == 'CS'" color="white">
                                CONOCE SUFICIENTE
                            </v-chip>
                            <v-chip v-if="item.nivelocu == 'CP'" color="white">
                                CONOCE PARCIAL
                            </v-chip>
                        </template>
                    </v-data-table>
                </v-card>

                <v-card color="blue lighten-4" tile>
                    <v-card-actions>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea dense rows="2" auto-grow outlined v-model="comentario"
                                    label="Observaciones / Comentarios"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
                <v-card color="blue lighten-5" tile>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="6">
                            <div class="d-flex" style="max-width:600px ; margin:10px">
                                <h6><b> EDUCACIÓN </b></h6>
                            </div>
                            <hr>
                            <div class="d-flex" style="max-width:600px ; margin:10px">
                                <h6><b> Primario: </b></h6>
                                <v-radio-group v-model="pri" row dense>
                                    <v-radio label="Completo" value="C"></v-radio>
                                    <v-radio label="Incompleto" value="I"></v-radio>
                                </v-radio-group>
                                <v-text-field dense label="Grado" outlined v-model="prigrado"></v-text-field>
                            </div>
                            <div class="d-flex" style="max-width:600px; margin:10px">
                                <h6><b> Secundario: </b></h6>
                                <v-radio-group v-model="sec" row dense>
                                    <v-radio label="Completo" value="C"></v-radio>
                                    <v-radio label="Incompleto" value="I"></v-radio>
                                </v-radio-group>
                                <v-text-field dense label="Año" outlined v-model="secgrado"></v-text-field>
                            </div>
                            <div class="d-flex" style="max-width:600px; margin:10px">
                                <v-text-field dense label="Orientación" outlined v-model="secorient"></v-text-field>
                            </div>
                            <div class="d-flex" style="max-width:600px; margin:10px">
                                <h6><b> Universidad: </b></h6>
                                <v-radio-group v-model="univ" row dense>
                                    <v-radio label="Completo" value="C"></v-radio>
                                    <v-radio label="Incompleto" value="I"></v-radio>
                                </v-radio-group>
                                <v-text-field dense label="Año" outlined v-model="univgrado"></v-text-field>
                            </div>
                            <div class="d-flex" style="max-width:600px; margin:10px">
                                <v-text-field dense label="Especialidad" outlined v-model="univorient"></v-text-field>
                            </div>
                            <div class="d-flex" style="max-width:600px; margin:10px">
                                <v-text-field dense label="Especialidad Posgrado" outlined
                                    v-model="postorient"></v-text-field>
                            </div>
                            <hr>

                        </v-col>
                        <v-col cols="12" sm="12" md="6">
                            <v-card-subtitle> EXPERIENCIA ANTERIOR / OTRAS</v-card-subtitle>
                            <v-card-actions>
                                <v-row dense>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-textarea dense rows="6" auto-grow outlined
                                            v-model="experiencia"></v-textarea>

                                        <v-select dense v-model="estado" :items="estados" label="Estado"
                                            item-text="nombre" item-value="valor"></v-select>
                                        <h6>
                                            <li>POLIVALENCIAS: </li>
                                            <li>Puntaje de Polivalencias (Nivel Ocupante): {{ puntaje1 }}</li>
                                            <li>Puntaje de Polivalencias (Nivel Requerido): {{ puntaje3 }}</li>
                                            <li>Relación entre Nivel Ocupante y Nivel Requerido: {{ relacionp1p3 }}
                                                %</li>
                                            <li>POLICOMPETENCIAS:</li>
                                            <li>Puntaje de Policompetencias: {{ puntaje2 }}</li>
                                        </h6>
                                    </v-col>
                                </v-row>

                            </v-card-actions>
                        </v-col>
                    </v-row>

                </v-card>
            </v-form>
        </v-app>
    </div>
</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}
</style>

<style scoped>
h6 {
    color: black;
}

.font-class-name {
    font-size: 14px;
}

.educacion {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
}

.educacion__niveles {
    border: solid 1px;
    list-style: none;
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        usuario: "",
        valid: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        fecha: moment().format("DD/MM/YYYY"),
        nombre: "",
        resp: "",
        gerencia: "",
        listadogerencia: [
            { nombre: "Seleccione una Gerencia", value: "" },
            { nombre: "Dirección General", value: "D" },
            { nombre: "Administración y Finanzas", value: "A" },
            { nombre: "Comercialización", value: "C" },
            { nombre: "Fabricación", value: "F" },
            { nombre: "Obras y Servicios", value: "O" },
            { nombre: "SGI", value: "S" },
            { nombre: "SSGG y Mantenimiento", value: "M" },
            { nombre: "Sucursal Bs As", value: "B" },
            { nombre: "Técnica y Desarrollo", value: "T" },
        ],
        listadoperiodo: [],
        listadopolivalencia: [],
        opcion: [
            { nombre: "No Conoce", value: "NC" },
            { nombre: "Conoce Parcial", value: "CP" },
            { nombre: "Conoce Suficiente", value: "CS" },
            { nombre: "Domina", value: "DO" },
            { nombre: "Puede Capacitar", value: "PC" },
        ],
        opcioncapac: [
            { nombre: "NO", value: "NO" },
            { nombre: "SI", value: "SI" },
        ],
        opcionprior: [
            { nombre: "-", value: "-" },
            { nombre: "A", value: "A" },
            { nombre: "B", value: "B" },
            { nombre: "C", value: "C" },
        ],
        opcionform: [
            { nombre: "Autoaprendizaje", value: "AA" },
            { nombre: "Capacitación Interna", value: "CI" },
            { nombre: "Capacitación Externa", value: "CE" },
            { nombre: "Capac. Interna/Externa", value: "IE" },
            { nombre: "Autoapr/C.Interna/C.Externa", value: "AC" },
            { nombre: "Visita Ferias/Expo/Fábricas", value: "VF" },
            { nombre: "Lectura Normas", value: "LN" },
            { nombre: "Otras", value: "OT" },
        ],
        sector: "",
        puesto: "",
        dialog: false,
        dialogDelete: false,
        dialogPC: false,
        dialogDeletePC: false,
        headers: [
            { text: "Polivalencia", value: "descr", width: "30%", sortable: false },
            { text: "Nivel Requerido", value: "nivelreq", sortable: false },
            { text: "Nivel Ocupante", value: "nivelocu", sortable: false },
            { text: "Requiere Capacitación", value: "capacitacion", sortable: false },
            { text: "Prioridad", value: "prioridad", sortable: false },
            { text: "Formación Sugerida", value: "formacion", sortable: false },
            { text: "Objetivo / Observación", value: "objetivo", sortable: false },
        ],
        headersPC: [
            { text: "Policompetencia", value: "descr", width: "30%", sortable: false },
            { text: "Nivel Ocupante", value: "nivelocu", sortable: false },
        ],
        editedIndex: -1,
        editedItem: {
            descr: "",
            nivelreq: "",
            nivelocu: "",
            capacitacion: "",
            prioridad: "",
            formacion: "",
            objetivo: "",
        },
        defaultItem: {
            descr: "",
            nivelreq: "",
            nivelocu: "",
            capacitacion: "",
            prioridad: "",
            formacion: "",
            objetivo: "",
        },
        editedIndexPC: -1,
        editedItemPC: {
            descr: "",
            nivelocu: "",
        },
        defaultItemPC: {
            descr: "",
            nivelocu: "",
        },
        polivalencias: [],
        policompetencias: [],
        observ: "",
        pri: "",
        prigrado: "",
        sec: "",
        secgrado: "",
        secorient: "",
        univ: "",
        univgrado: "",
        univorient: "",
        post: "",
        postorient: "",
        experiencia: "",
        comentario: "",
        estado: "",
        estados: [
            { nombre: 'Pendiente', valor: 'P' },
            { nombre: 'Cerrado', valor: 'C' },
        ],
        puntaje1: "",
        puntaje2: "",
        puntaje3: "",
        relacionp1p3: "",
        polivc: [],
        deshabilitar: false,
    }),

    // props: ["visible", "legajo", "periodo"],
    computed: {

        // show: {
        //     get() {
        //         if (this.legajo != "" && this.periodo != "" && this.legajo != null && this.periodo != null) {
        //             this.cargarDatos();
        //         }
        //         return this.visible;
        //     },
        //     set(value) {
        //         if (!value) {
        //             this.vaciarListado();
        //             this.$refs.form.resetValidation();
        //             document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
        //             this.$emit("close");
        //         }
        //     },
        // },
    },

    beforeMount() {

        this.legajo = this.$route.query.legajo
        this.periodo = this.$route.query.periodo
        this.cargarDatos();

    },

    methods: {


        cargarDatos() {
            let self = this;
            self.policompetencias = []
            self.polivalencias = []
            axios
                .get("/RRHH/CargarPlanilla", {
                    params: {
                        legajo: self.legajo,
                    },
                })
                .then((response) => {
                    self.nombre = response.data.nombre;
                    self.fecha = response.data.fecha;
                    if (response.data.gerencia == "D") {
                        self.gerencia = "Dirección General";
                    }
                    if (response.data.gerencia == "A") {
                        self.gerencia = "Administración y Finanzas";
                    }
                    if (response.data.gerencia == "C") {
                        self.gerencia = "Comercialización";
                    }
                    if (response.data.gerencia == "F") {
                        self.gerencia = "Fabricación";
                    }
                    if (response.data.gerencia == "O") {
                        self.gerencia = "Obras y Servicios";
                    }
                    if (response.data.gerencia == "S") {
                        self.gerencia = "SGI";
                    }
                    if (response.data.gerencia == "M") {
                        self.gerencia = "SSGG y Mantenimiento";
                    }
                    if (response.data.gerencia == "B") {
                        self.gerencia = "Sucursal Bs As";
                    }
                    if (response.data.gerencia == "T") {
                        self.gerencia = "Técnina y Desarrollo";
                    }
                    self.sector = response.data.sector;
                    self.puesto = response.data.puesto;
                    self.resp = response.data.resp;
                    self.pri = response.data.pri;
                    self.prigrado = response.data.prigrado;
                    self.sec = response.data.sec;
                    self.secgrado = response.data.secgrado;
                    self.secorient = response.data.secorient;
                    self.univ = response.data.univ;
                    self.univgrado = response.data.univgrado;
                    self.univorient = response.data.univorient;
                    self.post = response.data.post;
                    self.postorient = response.data.postorient;
                    self.experiencia = response.data.experiencia;
                    self.comentario = response.data.comentario;
                    self.estado = response.data.estado;
                    self.puntaje1 = response.data.puntaje1;
                    self.puntaje2 = response.data.puntaje2;
                    self.puntaje3 = response.data.puntaje3;
                    self.relacionp1p3 = response.data.relacionp1p3;
                    response.data.necesidades.forEach((element) => {
                        if (element.tipo == "PV") {
                            self.polivalencias.push(element);
                        }
                        if (element.tipo == "PC") {
                            self.policompetencias.push(element);
                        };
                    });
                })
                .catch((error) => {
                    self.polivalencias = [];
                    console.log(error);
                });
        },


        vaciarListado() {
            this.poliv = [];
            this.resp = "";
            this.gerencia = "";
            this.puesto = "";
            this.sector = "";
            this.fecha = "";
            this.pri = "";
            this.prigrado = "";
            this.sec = "";
            this.secgrado = "";
            this.secorient = "";
            this.univ = "";
            this.univgrado = "";
            this.univorient = "";
            this.post = "";
            this.postorient = "";
            this.experiencia = "";
            this.comentario = "";
            this.estado = "";
            this.polivalencias = [];
            this.policompetencias = [];
            this.polivc = [];
        },


    },
};
</script>
